import React from 'react';
import clsx from 'clsx';
import { CircleCheck } from 'lucide-react';
import { CountBubble } from './CountBubble';

export interface MethodTileProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
    label: React.ReactNode;
    sub?: React.ReactNode;
    icon?: React.ReactNode;
    /** image url instead of an icon */
    img?: string | null;
    selected?: boolean;
    /** Dashed "Lainnya" tile with a hidden-count bubble */
    more?: number;
    /** stacked = icon above label (phone grid) · inline = icon · label · check */
    layout?: 'stacked' | 'inline';
}

/** Payment method tile for checkout and top up. */
export const MethodTile: React.FC<MethodTileProps> = ({ label, sub, icon, img, selected = false, more, layout = 'stacked', className, type = 'button', ...props }) => {
    const visual = img ? <img src={img} alt="" className="w-[22px] h-[22px] object-contain" /> : <span className="inline-flex [&>svg]:w-[22px] [&>svg]:h-[22px]">{icon}</span>;
    const state = more !== undefined
        ? 'bg-surface-sunken border border-dashed border-line text-ink-brand'
        : selected
            ? 'bg-brandsoft border-2 border-primary-500 text-ink-brand'
            : 'bg-surface-card border border-line text-ink-primary hover:border-primary-500';

    if (layout === 'inline') {
        return (
            <button type={type} aria-pressed={selected} className={clsx('relative flex h-[60px] lg:h-16 items-center gap-2.5 rounded-md px-4 text-left transition-colors', state, className)} {...props}>
                <span className={clsx(!selected && more === undefined && 'text-ink-secondary')}>{visual}</span>
                <span className="min-w-0 flex-1">
                    <span className={clsx('block truncate text-base', selected ? 'font-black' : 'font-extrabold')}>{label}</span>
                    {sub && <span className={clsx('block truncate text-xs font-bold', selected ? 'text-ink-brand/80' : 'text-ink-muted')}>{sub}</span>}
                </span>
                {selected && more === undefined && <CircleCheck className="w-5 h-5 shrink-0" />}
                {more !== undefined && <CountBubble count={more} tone="inverse" />}
            </button>
        );
    }
    return (
        <button type={type} aria-pressed={selected} className={clsx('relative flex h-[72px] flex-col items-center justify-center gap-1.5 rounded-md px-1 text-[13px] transition-colors', selected ? 'font-black' : 'font-extrabold', state, className)} {...props}>
            <span className={clsx(!selected && more === undefined && 'text-ink-secondary')}>{visual}</span>
            <span className="max-w-full truncate">{label}</span>
            {more !== undefined && <CountBubble count={more} tone="inverse" className="absolute top-1.5 right-1.5 !h-5 !min-w-[20px] !text-[11px]" />}
        </button>
    );
};
export default MethodTile;
